export default __webpack_public_path__ + "_/shared_modules/continue-app/images/loan-app-in-progress-142f067ab8aabd0de45ac179031c799e.svg";